<template>
  <el-dialog
      :visible.sync="visible"
      title="物料单耗设置"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="90px"
    >
      <el-form-item prop="count" label="计划单耗：">
        <el-input v-model="dataForm.count" size="mini"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible=false" size="mini">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()" size="mini">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { countValidator } from '@/utils/validate'
import debounce from 'lodash/debounce'

export default {
  name: 'SetCount',
  data () {
    return {
      visible: false,
      dataForm: {
        bomIds: [],
        count: null,
      },
      dataRule () {
        return {
          count: [
            { required: true, message: '请填写数量', trigger: 'change' },
            { validator: countValidator, trigger: 'change' }
          ],
        }
      },
    }
  },
  methods: {
    init(){
      this.visible=true
      this.$nextTick(()=>{
        this.$refs.dataForm.clearValidate()
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate(
          (valid) => {
            if (!valid) {
              return false
            }

            let postForm = this.$clone(this.dataForm)
            this.$api.post(`/erp/bom/set/count`,postForm).then(res=>{
              this.$emit('change', postForm)
              this.$c.success('操作成功').then(res=>{
                this.visible = false
              })
            })
          },
          1000,
          { leading: true, trailing: false }
      )
    }),
  }
}
</script>

<style scoped>

</style>
